export default __webpack_public_path__ + "static/media/404-background.fba87140.svg";